import { ClearTransientAccessCredCommand } from '../../../prevent_transient_access/commands/clear_transient_access_cred_command';
import { SectionSwapPreviewQuery } from '../../queries/section_swap_preview_query';
import { LoadSectionRegistrationAttributesCommand } from '../../../registration_attributes/commands/load_section_registration_attributes_command';
import { ICommand, IQuery } from 'core-ts-types';
import { ISection } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { SectionSwapModel } from '../../models/course_section_swap_model';
import { ScheduledSectionStatus } from '../../../views/course_scheduler/types/scheduled_section_status_enum';
import { TermPinServant } from '../../../components/term_pin/servants/term_pin_servant';

export class SwapFooterController {
  private showSwapDialog: boolean = false;
  private showSwapErrorDialog: boolean = false;
  constructor(
    private ngSectionSwapPreviewSwapQuery: SectionSwapPreviewQuery,
    private $state: ng.ui.IStateService,
    private $stateParams: ng.ui.IStateParamsService,
    private ngCourseSectionSwapModel: SectionSwapModel,
    private updateSwapSectionStatusCommand: ICommand,
    private getTermPinCommand: ICommand,
    private ngTermPinServant: TermPinServant,
    private $q: ng.IQService,
    private clearTransientAccessCredCommand: ClearTransientAccessCredCommand,
    private loadSectionRegistrationAttributesCommand: LoadSectionRegistrationAttributesCommand
  ) {}
  exitSwap() {
    this.$state.go('my.schedule.registration');
    const toData = _4.compact(_4.map(this.ngCourseSectionSwapModel.read().swap_to_section_ids, 'id'));
    const fromData = _4.compact(_4.map(this.ngCourseSectionSwapModel.read().swap_from_section_ids, 'id'));
    this.updateSwapSectionStatusCommand(toData, '');
    this.ngCourseSectionSwapModel.clear();
    this.getTermPinCommand(this.$stateParams.termId);
  }
  closeSwapErrorDialog() {
    this.showSwapErrorDialog = false;
  }
  openSwapDialog() {
    if (this.ngSectionSwapPreviewSwapQuery.result.disableSwap) {
      this.showSwapErrorDialog = true;
      return;
    }
    const regAttributesForSections: Array<angular.IPromise<IQuery[]>> = [];
    this.ngSectionSwapPreviewSwapQuery.result.to.forEach((section) =>
      regAttributesForSections.push(this.loadSectionRegistrationAttributesCommand(section.id))
    );

    this.$q
      .all(regAttributesForSections.concat([this.clearTransientAccessCredCommand()]))
      .then(() => this.getTermPinCommand(this.$stateParams.termId))
      .then(() => {
        this.showSwapDialog = true;
      });
  }
}

angular.module('capability-ng-scheduler').component('swapFooter', {
  templateUrl: 'capability-ng-scheduler/src/swap/components/swap_footer/swap_footer.html',
  controller: SwapFooterController,
  bindings: {}
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/components/swap_footer/swap_footer.ts